import React, { useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Translation } from 'react-i18next'
import { DatePicker } from '@material-ui/pickers'
import {
  FormControlLabel,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  IconButton,
  Checkbox
} from '@material-ui/core/'
import ClearIcon from '@material-ui/icons/Clear'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import { getLocation } from '../selectors/invoice.selector'
import mobileView from './mobile.utils'
import { stringToArray } from './employer/stringArrayHandle.utils'

const styles = (theme) => ({
  root: {
    padding: '0px 8px'
  },
  form: {},
  textField: {
    marginTop: theme.spacing(3),
    fontFamily: 'Poppins, sans-serif',
    fontSize: '13px',
    border: '1px solid gray',
    width: '100%',
    paddingRight: '36px',
    // borderRadius:'1rem',
    maxWidth: '300px'
  },
  select: {
    outline: 'none',
    border: '1px solid gray',
    cursor: 'pointer',
    fontFamily: 'Poppins, sans-serif',
    textAlign: 'center',
    // lineHeight: '1.5',
    fontSize: '13px',
    minWidth: '179px'
  },
  invoiceFilter: {
    padding: '0px 8px'
  },
  filter: {
    padding: '0px 8px',
    flex: 1
  },
  filterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0px 8px',
    alignItems: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 8px',
      alignItems: 'stretch'
    }
  },
  button: {
    height: '38px',
    maxWidth: '160px'
  },
  buttonContainer: {
    paddingTop: '32px',
    margin: '0px 32px',
    marginLeft: 'auto'
  },
  clearFieldButton: {
    marginLeft: '-36px',
    marginRight: '4px',
    alignSelf: 'flex-end',
    marginBottom: '3px',
    height: '32px',
    width: '32px'
  },
  clearIcon: {
    height: '18px',
    width: '18px'
  },
  compactCheckbox: {
    paddingTop: '16px',
    paddingBottom: '6px',
    fontSize: '15px',
    fontWeight: 500,
    color: '#808080'
  }
})

const debouncedFunction = _.debounce((fn, parameters) => {
  fn(parameters)
}, 500)

function FilterFields(props) {
  const { classes, data, headerCells, handleChangeFilterValue } = props

  const [filterValues, setFilterValues] = React.useState({})

  const handleValueChange = (value, id) => {
    setFilterValues({ ...filterValues, [id]: value })
  }

  useEffect(() => {
    handleChangeFilterValue(filterValues)
  }, [filterValues])

  return (
    <div className={classes.root}>
      <form className={classes.form} component="div">
        <div className={classes.filterContainer}>
          {headerCells.map((headerCell) => (
            <div key={headerCell.id} className={classes.filter}>
              {getField(
                classes,
                data,
                headerCell,
                filterValues,
                handleValueChange
              )}
            </div>
          ))}
        </div>
      </form>
    </div>
  )
}

FilterFields.propTypes = {
  headerCells: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(FilterFields)

function getField(classes, data, headerCell, filterValues, handleValueChange) {
  const location = useSelector(getLocation)
  const minDate =
    location === '/dashboard/invoice' && filterValues?.billing_date
      ? filterValues.billing_date
      : location === '/dashboard/salary' && filterValues?.created
      ? filterValues.created
      : undefined
  const maxDate =
    location === '/dashboard/invoice' && filterValues?.toDate
      ? filterValues.toDate
      : location === '/dashboard/salary' && filterValues?.toDate
      ? filterValues.toDate
      : undefined
  switch (headerCell.filter.type) {
    case 'select':
      return (
        <SelectFilter
          classes={classes}
          key={headerCell.id}
          headerCell={headerCell}
          options={headerCell.filter.options}
          filterValues={filterValues}
          handleValueChange={handleValueChange}
          data={data}
        />
      )
    case 'selectLightEntrepreneur':
      return (
        <SelectFilterLightEntrepreneur
          classes={classes}
          key={headerCell.id}
          headerCell={headerCell}
          options={headerCell.filter.options}
          filterValues={filterValues}
          handleValueChange={handleValueChange}
          data={data}
        />
      )
    case 'date':
      return (
        <DateFilter
          classes={classes}
          key={headerCell.id}
          headerCell={headerCell}
          filterValues={filterValues}
          handleValueChange={handleValueChange}
        />
      )
    case 'dateFrom':
      return (
        <DateFilter
          classes={classes}
          key={headerCell.id}
          headerCell={headerCell}
          filterValues={filterValues}
          handleValueChange={handleValueChange}
          maxDate={maxDate}
        />
      )
    case 'dateTo':
      return (
        <DateFilter
          classes={classes}
          key={headerCell.id}
          headerCell={headerCell}
          filterValues={filterValues}
          handleValueChange={handleValueChange}
          minDate={minDate}
        />
      )

    case 'number':
    case 'string':
      return (
        <TextFieldFilter
          classes={classes}
          key={headerCell.id}
          headerCell={headerCell}
          filterValues={filterValues}
          handleValueChange={handleValueChange}
        />
      )
    case 'checkbox':
      return (
        <CheckboxFilter
          classes={classes}
          key={headerCell.id}
          headerCell={headerCell}
          filterValues={filterValues}
          handleValueChange={handleValueChange}
        />
      )
    default:
      return null
  }
}

function DateFilter(props) {
  const {
    classes,
    headerCell,
    filterValues,
    handleValueChange,
    minDate,
    maxDate
  } = props

  const handleChange = (date) => {
    date.setHours(0, 0, 0, 0)
    handleValueChange(date, headerCell.id)
  }

  const handleReset = () => {
    handleValueChange(null, headerCell.id)
  }

  return (
    <Translation>
      {(t) => (
        <div style={{ display: 'flex' }}>
          <DatePicker
            label={
              headerCell.label === 'invoice.column2' ||
              headerCell.label === 'salaryCompo.table'
                ? t('invoice.table2')
                : headerCell.label === 'invoice.column3' ||
                  headerCell.label === 'toDate'
                ? t('invoice.table3')
                : t(headerCell.label)
            }
            value={filterValues[headerCell.id] || null}
            onChange={handleChange}
            format={'dd.MM.yyyy'}
            InputProps={{
              classes: {
                input: classes.textField
              },
              disableUnderline: true
            }}
            InputLabelProps={{
              shrink: false,
              style: { fontSize: '14px', fontWeight: 500, color: '#222' }
            }}
            minDate={minDate}
            maxDate={maxDate}
          />
          {!filterValues[headerCell.id] ? null : (
            <IconButton
              onClick={handleReset}
              className={classes.clearFieldButton}
            >
              <ClearIcon className={classes.clearIcon} />
            </IconButton>
          )}
        </div>
      )}
    </Translation>
  )
}

function SelectFilter(props) {
  const {
    classes,
    headerCell,
    options,
    filterValues,
    handleValueChange,
    data
  } = props

  // For sub filter - select bar
  const [selectedOption, setSelectedOption] = React.useState('')

  const handleChange = (e) => {
    handleValueChange(e.target.value, headerCell.id)
    if (e.target.value == '' || e.target.value == 1 || e.target.value == 2) {
      setSelectedOption(e.target.value)
    } else {
      setSelectedOption(null)
    }
  }

  const dd = getDistinctValues(
    data,
    headerCell.id,
    headerCell.filter.locationView
  )
  const lbs = []
  for (let i = 0; i < dd.length; i++) {
    if (headerCell.filter.labelConverter) {
      lbs.push(
        headerCell.filter.labelConverter(
          dd[i],
          headerCell.filter.locationView === 'userView' ? 'userView' : null
        )
      )
    }
  }

  return (
    <Translation>
      {(t) => (
        <FormControl style={{ marginTop: '24px' }}>
          <div
            style={
              mobileView
                ? {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '20px',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    width: '100%'
                  }
                : { display: 'flex', alignItems: 'center', gap: '16px' }
            }
          >
            <InputLabel
              shrink
              style={{
                marginTop: '-3px',
                fontSize: '19px',
                fontWeight: 500,
                color: '#222'
              }}
            >
              {t(headerCell.label)}
            </InputLabel>
            <Select
              className={classes.select}
              disableUnderline={true}
              value={filterValues[headerCell.id] || ''}
              style={{ textAlign: 'left' }}
              onChange={handleChange}
            >
              <MenuItem value="">{t('names.all')}</MenuItem>
              {options
                ? options.map((el) => (
                    <MenuItem key={el.value} value={el.value}>
                      {headerCell.filter.noTranslate ? el.label : t(el.label)}
                    </MenuItem>
                  ))
                : getDistinctValues(
                    data,
                    headerCell.id,
                    headerCell.filter.locationView
                  ).map((value) => (
                    <MenuItem key={value} value={value.toString()}>
                      {headerCell.filter.noTranslate
                        ? headerCell.filter.labelConverter(
                            value,
                            headerCell.filter.locationView === 'userView'
                              ? 'userView'
                              : null
                          )
                        : t(
                            headerCell.filter.labelConverter(
                              value,
                              headerCell.filter.locationView === 'userView'
                                ? 'userView'
                                : null
                            )
                          )}
                    </MenuItem>
                  ))}
            </Select>
            {headerCell.filter.invoiceStatus === 'extraFilter' ? (
              <SimpleSelectBar
                headerCell={headerCell}
                options={getDistinctValues(
                  data,
                  headerCell.id,
                  headerCell.filter.locationView
                )}
                handleValueChange={handleValueChange}
                t={t}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
              />
            ) : null}
          </div>
        </FormControl>
      )}
    </Translation>
  )
}
function SelectFilterLightEntrepreneur(props) {
  const { classes, headerCell, filterValues, handleValueChange, data } = props

  const handleChange = (e) => {
    handleValueChange(e.target.value, headerCell.id)
  }

  return (
    <Translation>
      {(t) => (
        <FormControl style={{ marginTop: '24px' }}>
          <div
            style={
              mobileView
                ? {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '20px',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    width: '100%'
                  }
                : { display: 'flex', alignItems: 'center', gap: '16px' }
            }
          >
            <InputLabel
              shrink
              style={{
                marginTop: '-3px',
                fontSize: '19px',
                fontWeight: 500,
                color: '#222'
              }}
            >
              {t(headerCell.label)}
            </InputLabel>
            <Select
              className={classes.select}
              disableUnderline={true}
              value={filterValues[headerCell.id] || ''}
              style={{ textAlign: 'left' }}
              onChange={handleChange}
            >
              <MenuItem value="">{t('employer.names.all')}</MenuItem>
              {getDistinctValues(
                data,
                headerCell.id,
                headerCell.filter.locationView
              ).map((value) => (
                <MenuItem key={value} value={value}>
                  {headerCell.id === 'AreaOfWork'
                    ? t(`employer.areaOfWork.${value}`)
                    : t(`employer.areaOfExpertiseList.${value}`)}
                </MenuItem>
              ))}
            </Select>
          </div>
        </FormControl>
      )}
    </Translation>
  )
}

SelectFilter.propTypes = {
  classes: PropTypes.object.isRequired,
  headerCell: PropTypes.object.isRequired,
  options: PropTypes.array
}

const SimpleSelectBar = ({
  headerCell,
  options,
  handleValueChange,
  t,
  selectedOption,
  setSelectedOption
}) => {
  const modifyOption = ['', ...options]

  const handleChange = (option) => {
    handleValueChange(option, headerCell.id)
    setSelectedOption(option)
  }

  return (
    <div style={{ display: 'flex', gap: '10px', marginTop: 'auto' }}>
      {modifyOption
        .filter((value) => value === '' || value === 1 || value === 2) // All, Sent, Paid - invoice status
        .map((option) => (
          <div
            key={option}
            onClick={() => handleChange(option)}
            style={{
              fontSize: '13px',
              padding: '8px 10px',
              cursor: 'pointer',
              color: selectedOption == option ? '#fff' : '#222222',
              backgroundColor: selectedOption == option ? '#44c0cc' : '#f8f9fa',
              borderRadius: '10px',
              boxShadow:
                selectedOption === option
                  ? '0px 2px 6px rgba(0, 0, 0, 0.2)'
                  : '0px 1px 3px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
          >
            {option === ''
              ? t('names.all')
              : t(
                  headerCell.filter.labelConverter(
                    option,
                    headerCell.filter.locationView === 'userView'
                      ? 'userView'
                      : null
                  )
                )}
          </div>
        ))}
    </div>
  )
}

function TextFieldFilter(props) {
  const { classes, headerCell, handleValueChange } = props

  const [value, setValue] = React.useState('')

  const handleChange = (e) => {
    setValue(e.target.value)
  }

  const updateFilterValues = (newValue) => {
    handleValueChange(newValue === '' ? null : newValue, headerCell.id)
  }

  useEffect(() => {
    debouncedFunction(updateFilterValues, value)
  }, [value])

  const handleReset = () => {
    setValue('')
    handleValueChange(null, headerCell.id)
  }

  return (
    <Translation>
      {(t) => (
        <div style={{ display: 'flex' }}>
          <TextField
            type={headerCell.filter.type === 'number' ? 'number' : 'text'}
            label={t(headerCell.label)}
            value={value}
            onChange={handleChange}
            InputProps={{
              classes: {
                input:
                  headerCell.filter.type === 'number'
                    ? classNames(classes.textField, 'hide-arrows')
                    : classes.textField
              },
              disableUnderline: true
            }}
            InputLabelProps={{
              shrink: false,
              style: { fontSize: '14px', fontWeight: 500, color: '#222' }
            }}
          />
          {value.length === 0 ? null : (
            <IconButton
              onClick={handleReset}
              className={classes.clearFieldButton}
            >
              <ClearIcon className={classes.clearIcon} />
            </IconButton>
          )}
        </div>
      )}
    </Translation>
  )
}

function CheckboxFilter(props) {
  const { classes, headerCell, filterValues, handleValueChange } = props

  const handleCheck = (e) => {
    handleValueChange(e.target.checked, headerCell.id)
  }

  return (
    <Translation>
      {(t) => (
        <div style={{ display: 'flex' }}>
          <FormControlLabel
            label={t(headerCell.label)}
            classes={{
              label: classes.compactCheckbox
            }}
            control={
              <Checkbox
                checked={filterValues[headerCell.id] || false}
                onChange={handleCheck}
                className={classes.compactCheckbox}
              />
            }
          />
        </div>
      )}
    </Translation>
  )
}

//get distinct values of a property from an array of objects
function getDistinctValues(array, property, locationView) {
  var unique = []
  var distinct = []
  for (let i = 0; i < array.length; i++) {
    if (locationView === 'employerView') {
      let properties = stringToArray(array[i][property])
      for (const element of properties) {
        if (!unique[element]) {
          distinct.push(element)
          unique[element] = 1
        }
      }
    } else {
      // Check the condition for locationView and property
      // KAS-697 - Do not need to take Paid (MP) to show at filter
      if (
        locationView === 'userView' &&
        property === 'status' &&
        array[i][property] === 24 // invoice status Paid (MP)
      ) {
        continue // Skip this item if it meets the condition
      }

      if (!unique[array[i][property]]) {
        distinct.push(array[i][property])
        unique[array[i][property]] = 1
      }
    }
  }

  return distinct
}
